import React from 'react';
import PropTypes from 'prop-types';
import CorrClusterView from './CorrClusterView';
import CacMapTitleAndDropdown from '../CacMapTitleAndDropdown';
import CorrDataView from './CorrDataView';

const CorrViewRightContent = props => {
  const { project, projectTitle, redrawChart } = props;
  const corrMapView = project.corrMapView;

  return (
    <div className="view-right-content" data-test="cacViewRightComponent">
      <CacMapTitleAndDropdown
        projectTitle={projectTitle}
      />
      {project.corrResponse.cm && (corrMapView ?
        (<CorrClusterView
          id="scatterZoomChart"
          zoomType="detail"
          redrawChart={redrawChart}
          project={project}
        />) :
        <CorrDataView
          project={project}
        />)
      }
      {project.corrResponse.errMsg && (<div className="outerDiv" data-test="outerDiv">
        <div className="errorMessage">{project.corrResponse.errMsg}</div>
        </div>)
      }
    </div>
  );
};

CorrViewRightContent.propTypes = {
  redrawChart: PropTypes.bool,
  project: PropTypes.shape({
    corrMapView: PropTypes.bool,
    corrResponse: {},
  }),
  projectTitle: PropTypes.string,
};

export default CorrViewRightContent;
